<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M8.2812 12.9167C8.2068 12.6283 8.05648 12.3651 7.84588 12.1545C7.63528 11.9439 7.37209 11.7936 7.0837 11.7192L1.9712 10.4009C1.88398 10.3761 1.80721 10.3236 1.75254 10.2512C1.69788 10.1789 1.6683 10.0907 1.6683 10C1.6683 9.90938 1.69788 9.82118 1.75254 9.74884C1.80721 9.6765 1.88398 9.62397 1.9712 9.59921L7.0837 8.28005C7.37199 8.20572 7.63511 8.05552 7.8457 7.84508C8.05629 7.63463 8.20667 7.37162 8.2812 7.08338L9.59953 1.97088C9.62404 1.88331 9.67652 1.80616 9.74897 1.75121C9.82141 1.69625 9.90985 1.6665 10.0008 1.6665C10.0917 1.6665 10.1802 1.69625 10.2526 1.75121C10.325 1.80616 10.3775 1.88331 10.402 1.97088L11.7195 7.08338C11.7939 7.37177 11.9443 7.63496 12.1549 7.84556C12.3655 8.05616 12.6286 8.20648 12.917 8.28088L18.0295 9.59838C18.1175 9.62263 18.195 9.67505 18.2502 9.74761C18.3055 9.82017 18.3354 9.90885 18.3354 10C18.3354 10.0912 18.3055 10.1799 18.2502 10.2525C18.195 10.325 18.1175 10.3775 18.0295 10.4017L12.917 11.7192C12.6286 11.7936 12.3655 11.9439 12.1549 12.1545C11.9443 12.3651 11.7939 12.6283 11.7195 12.9167L10.4012 18.0292C10.3767 18.1168 10.3242 18.1939 10.2518 18.2489C10.1793 18.3038 10.0909 18.3336 9.99995 18.3336C9.90902 18.3336 9.82058 18.3038 9.74813 18.2489C9.67569 18.1939 9.62321 18.1168 9.5987 18.0292L8.2812 12.9167Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.6667 2.5L16.6667 5.83333"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M18.3333 4.16675L15 4.16675"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.33334 14.1667L3.33334 15.8334"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M4.16667 15L2.5 15"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconInspirator',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: '#FECC30'
		},
		filled: {
			type: Boolean,
			default: false
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.3
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
